import React from "react";
import { Badge } from "reactstrap";

import { Localisation } from "@localisation/index";
import { Locale } from "@localisation/models";
import { BundleStatus as Model } from "../../models";

interface BundleStatusProps {
    value: Model;
    locale: Locale;
}

export const BundleStatus = ({ value, locale }: BundleStatusProps) => {
    let color = "warning";
    if (value != null) {
        if (value.name === "error") {
            color = "danger";
        }
        else if (value.name === "complete") {
            color = "success";
        }
    }
    return (
        <Badge className="bundle-status" color={color}>
            {value != null && value.label != null ? Localisation.translateMap(value.label, locale) : ""}
        </Badge>
    );
};
